import { Icon, IconProps, Image } from "@chakra-ui/react";

export const LoginIllustration = (props: IconProps) => {
    return (
        <Image src="/tree.png"></Image>
    );
};